"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCy = exports.SidePageTitle = void 0;
var _Grid = _interopRequireDefault(require("../Grid"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));
var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));
var _styles = require("@mui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "subTitle", "actions", "onClose", "entityId", "children", "titleVariant", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      boxShadow: 'none',
      zIndex: 1,
      height: '64px',
      justifyContent: 'center',
      color: theme.palette.text.primary,
      borderBottom: "1px solid ".concat(theme.palette.divider),
      boxSizing: 'border-box'
    },
    actions: {
      width: 'auto !important',
      flexWrap: 'nowrap'
    },
    overflowEllipsis: {
      overflowWrap: 'anywhere',
      flexWrap: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    withChildren: {
      paddingLeft: '12px',
      justifyContent: 'space-between'
    }
  };
}, {
  name: 'GgSidePageTitle'
});
var dataCy = exports.dataCy = 'SidePageTitle';
var SidePageTitle = exports.SidePageTitle = function SidePageTitle(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    actions = _ref.actions,
    onClose = _ref.onClose,
    entityId = _ref.entityId,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    titleVariant = _ref.titleVariant,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var titleVariantNormalized = titleVariant ? titleVariant : subTitle ? 'caption' : 'h6';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
      "data-cy": dataCy,
      className: (0, _clsx2["default"])(className, classes.root)
    }, props), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Toolbar["default"], {
        className: (0, _clsx2["default"])(_defineProperty({}, classes.withChildren, !!children)),
        children: [title || subTitle || entityId ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid["default"], {
          container: true,
          direction: 'column',
          item: true,
          xs: true,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography["default"], {
            variant: titleVariantNormalized,
            className: classes.overflowEllipsis,
            "data-cy-role": 'title',
            lineClamp: 1,
            disableTooltip: true,
            children: [title, entityId ? " #".concat(entityId) : '']
          }), subTitle ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
            variant: 'subtitle1',
            "data-cy-role": 'subtitle',
            className: classes.overflowEllipsis,
            sx: {
              fontWeight: 500
            },
            lineClamp: 1,
            disableTooltip: true,
            children: subTitle
          }) : null]
        }) : null, children, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid["default"], {
          container: true,
          justifyContent: 'flex-end',
          alignItems: 'center',
          className: classes.actions,
          children: [actions ? actions : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
            "data-cy-action": 'close',
            "data-cy": 'IconButton',
            "data-cy-icon": 'close',
            variant: 'outlined',
            "data-cy-label": 'close',
            component: 'span',
            onClick: onClose,
            edge: 'end',
            size: 'large',
            tooltip: 'Close',
            tooltipPlacement: 'bottom',
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close["default"], {})
          })]
        })]
      })
    }))
  });
};